<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9q1Tvt/image/1.png?1688985129300" alt="This image is the cover for the book Miss Daisy Weed's Other Half"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miss Daisy Weed's Other Half
      </h1>
      <p class="bookDescription body article font2">
        <p>In Miss Daisy Weed's Other Half, these two refreshing Daisies are learning to fly as they transform into flower fairies. Their adventures are many, some tug at our heartstrings, whilst others seem to leave us helpless with laughter. They learn many lessons, and as they travel, they help others who are less fortunate. Their fairy guide is the lovable Snowbell, who is in a world of her own. As the two flower fairies sit under a toadstool listening to fairy music, the fairy elders have a new task, that will once again have them flying to other parts of the world beyond their wildest dreams.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte Godkin
      </h2>
      
      <p class="authorDescription body article">Charlotte Godkin is a humorous lady who certainly lives in the world of fantasy. Her knowledge and imagination are expressed in this book. Charlotte lives in Northumberland close to the moors, where she is often seen walking her Chihuahua, gathering thoughts and wild flowers for her next book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07acf6a9